<template>
  <div class="empty">
    <img v-if="img" class="image" :src="img" />
    <img v-else class="image" src="@/images/empty/empty.png" />
    <p class="desc">
      {{ desc }}
    </p>
    <button v-if="showBtn" class="btn" @click="btnHandler">
      {{ btnText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmptyLayout',
  props: {
    img: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: '暂无数据'
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '返回'
    }
  },
  methods: {
    btnHandler() {
      this.$emit('btn-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.empty {
  .image {
    display: block;

    width: 120px;
    margin: 90px auto 30px auto;
  }

  .desc {
    width: 260px;
    margin: 0 auto;

    font-size: 14px;
    text-align: center;
    color: $c-text-lighter;

    @include text-overflow-ellipsis-single;
  }

  .btn {
    display: block;

    height: 38px;
    margin: 30px auto;
    padding: 0 26px;

    background: none;

    border-radius: 20px;
    border: none;
    border: 1px solid $theme-main;
    outline: none;

    font-size: 16px;
    line-height: 38px;
    text-align: center;

    color: $theme-main;
  }
}
</style>
